export const TRIGGER_SNACK_BAR = "SNACKBAR.TRIGGER";
export const HIDE_SNACK_BAR = "SNACKBAR.HIDE";
export const TOGGLE_SNACK_BAR = "TOGGLE_SNACK_BAR";